<template>
    <div class="ngdialog-content">
        <div class="ngdialog__header">
            <h4 v-if="alreadySent">{{$t('notifications.show_notification')}}</h4>
            <h4 v-else>{{$t('notifications.send_notification')}}</h4>
            <div class="ngdialog-close" @click="$emit('close')"></div>
        </div>

        <div class="ngdialog__body">
            <p>
                <b>{{$t('notifications.title')}}</b>
                <br>
                {{ notification.title }}
            </p>
            <p>
                <b>{{$t('notifications.body')}}</b>
                <br>
                {{ notification.body }}
            </p>
            <p v-if="organizationName">
                <b>{{$t('fields.organization')}}</b>
                <br>
                {{ organizationName }}
            </p>
            <p>
                <b>{{$t('notifications.language')}}</b>
                <br>
                <span v-if="notification.locale">{{$t('language.' + notification.locale)}}</span>
                
                <span class="capitalize" v-else>{{$t('common.all')}}</span>
            </p>
            <p>
                <b>{{$t('fields.notification')}}</b>
                <br>
                <span v-if="notification.via_email">{{$t('notifications.email')}}</span>
                <span v-if="notification.via_email && notification.via_push">,</span>
                <span v-if="notification.via_push">{{$t('notifications.push')}}</span>
            </p>
        </div>

        <div class="ngdialog__button-group">
            <div class="ngdialog__button-group__item">
                <a class="ngdialog__button ngdialog__button--secondary" @click="$emit('close')">
                    <span v-if="alreadySent" class="ngdialog__button__text">{{$t('buttons.close')}}</span>
                    <span v-else class="ngdialog__button__text">{{$t('buttons.cancel')}}</span>
                </a>
            </div>

            <div class="ngdialog__button-group__item" v-if="!alreadySent">
                <a
                    href="#"
                    @click="sendNotification()"
                    class="ngdialog__button"
                    same-height="dialog-button"
                    :class="{'ngdialog__button--disabled': loading}"
                >
                    <span class="ngdialog__button__text">{{$t('buttons.send')}}</span>
                    <i
                        class="ngdialog__button__spinner icon icon--common-spinner spinner"
                        :class="{'spinner--finished': !loading}"
                    ></i>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import * as api from '@/api';

export default {
    props: {
        notification: Object,
        alreadySent: Boolean,
        organizations: {
            type: [Object, Boolean],
            default: false
        },
    },
    data() {
        return {
            loading: false,
        };
    },
    computed: {
        organizationName() {
            if (this.organizations && this.notification.organization_id !== null) {
                const organization = this.organizations.find(organization => organization.id === this.notification.organization_id)
                return organization ? organization.name : false
            } else {
                return false
            }
        },
    },
    methods: {
        sendNotification() {
            this.loading = true;
            api.notifications.trigger({ noteid: this.notification.id }).then(
                () => {
                    this.loading = false;
                    this.$emit('close');
                },
                error => {
                    this.loading = false;
                    this.$notify({
                        type: 'error',
                        text: this.$t('error_could_not_send_notification'),
                    });
                }
            );
        },
    },
};
</script>

